import { render } from "./TimelineCard.vue?vue&type=template&id=4a546b3c&scoped=true"
import script from "./TimelineCard.vue?vue&type=script&lang=js"
export * from "./TimelineCard.vue?vue&type=script&lang=js"

import "./TimelineCard.vue?vue&type=style&index=0&id=4a546b3c&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a546b3c"]])

export default __exports__